<template>
<div :class="getClass">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      return this.noBorder ? 'no-border' : 'messaging-bar'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.messaging-bar {
  height: 6rem;
  min-height: 6rem;
  padding: 1rem;
  border-top: solid 1px $border-color;
  border-bottom: solid 1px $border-color;
}

.no-border{
  height: 6rem;
  min-height: 6rem;
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/messaging-bar.vue